import * as vp from 'vopay';

export type  RetriggerWebhookDialogueRows = {
  label: vp.RetriggerWebhookLabel;
  id: vp.RetriggerWebhookId;
  preset: keyof vp.TextFieldPresets | undefined;
  required: boolean;
  type: 'input';
  isVisible: boolean;
}

export const buildRetriggerWebhookDialogueRows = (
  variant: 'webhook-retrigger',
) : RetriggerWebhookDialogueRows[] => {

  return [
    {
      label: vp.RetriggerWebhookLabel.EventID,
      id: vp.RetriggerWebhookId.EventID,
      preset: 'text',
      type: 'input',
      required: variant === 'webhook-retrigger',
      isVisible: true,
    },
  ]
}